import { jsx as r } from "react/jsx-runtime";
import c from "classnames";
import { forwardRef as s } from "react";
import t from "./index.es720.js";
import { SearchIcon as u } from "./index.es325.js";
import { UnifiedInputField as d } from "./index.es56.js";
import { onKeyDownEnter as h } from "./index.es500.js";
const p = "search-field-component", R = s(
  ({
    size: a = "default",
    disabled: e,
    testId: i = p,
    fullWidth: m = !1,
    onClick: o,
    ...l
  }, n) => /* @__PURE__ */ r(
    "div",
    {
      className: c(t.searchField, {
        [t["search--full-width"]]: m
      }),
      children: /* @__PURE__ */ r(
        d,
        {
          ...l,
          disabled: e,
          testId: i,
          onClick: o,
          RightIcon: /* @__PURE__ */ r(
            u,
            {
              color: e ? "outline" : "blue",
              outline: e ? "disabled" : "default-gray"
            }
          ),
          ref: n,
          size: a,
          onKeyDown: (f) => h(f, o),
          "aria-label": l["aria-label"] || "Please Fill out your search query"
        }
      )
    }
  )
);
export {
  p as SEARCH_FIELD_DEFAULT_TESTID,
  R as SearchField
};
//# sourceMappingURL=index.es39.js.map
